import "bootstrap";
import $ from "jquery";
import { toggleTopbar } from "./toogle-topbar";
import { fixedNavbar } from "./fixed-navbar";
import AOS from "aos";

import swiperScripts from "./swiper";

AOS.init();

$(document).ready(function () {
  $(".first-button").on("click", function () {
    $(".animated-icon1").toggleClass("open");
  });
  $(".second-button").on("click", function () {
    $(".animated-icon2").toggleClass("open");
  });
  $(".third-button").on("click", function () {
    $(".animated-icon3").toggleClass("open");
  });
});

window.addEventListener("load", () => {
  toggleTopbar();
  fixedNavbar();
  swiperScripts();
});

$(document).ready(function () {
  function isMobile() {
    return $(window).width() <= 991;
  }

  // Add click event listener to .menu-item-has-children elements
  $(".menu-item-has-children").on("click", function (event) {
    if (isMobile()) {
      event.preventDefault(); // Prevent the default click behavior
      const $submenu = $(this).find(".sub-menu");
      $submenu.slideToggle(); // Toggle the display of the sub-menu
    }
  });
});
$(".menu-item-has-children .sub-menu li").on("click", function (event) {
  event.stopPropagation(); // Stop the click event from bubbling up to the parent element
});

$(document).ready(function () {
  var lastScrollTop = 0;

  $(window).on("scroll", function () {
    var scrollTop = $(this).scrollTop();
    var stickyBox = $(".sticky-box");

    if (stickyBox.length > 0) {
      if (scrollTop > lastScrollTop) {
        // Scrolling down
        stickyBox.css("top", "20px");
      } else {
        // Scrolling up
        stickyBox.css("top", "150px");
      }
    }

    lastScrollTop = scrollTop;
  });
});

$(document).ready(function () {
  $('.page-numbers').each(function () {
      var pageNumber = $(this).text();
      if (pageNumber.length == 1) {
          $(this).text('0' + pageNumber);
      }
  });
});

